/**
 * Retrieves B2C service Page data for displaying on a page.
 * @param {Function} t - The translation function used to translate text strings.
 * @returns {Object} An object containing B2C service Page data.
 */

export const getIndividualB2BData = (t) => {
  return {
    1: {
      overview: {
        source: 'B2B Logistics',
        heroHeader: 'Revolutionize Your ',
        heroHeader2: 'E-commerce logistics with ',
        heroSubHeader: 'XpressBees',
        heroPara:
          'Effortlessly optimize your supply chain, expand your reach, and reduce costs while receiving personalized service from dedicated account managers.',
        image: '/images/services/OverviewImg.webp',
        title: t('app.OVERVIEW'),
        alt: 'B2C logistics services',
        paragraph: [t('app.OVERVIEW_PARAGRAPH_1')],
      },

      whyChooseUsDetails: {
        technology: {
          info: 'Technology',
          title1: 'Leading Platform with',
          title2: 'Most Advanced Solutions',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: 'Multimodal Shipping (Air/Surface Shipping)',
              details:
                'Choose the best mode of transportation-air or surface-to suit your business needs. Optimize cost and speed for every shipment.',
              img: '/images/services/whyChooseUs-1.webp',
            },
            {
              title: 'Customised Bulk Shipping  with PTL & FTL  Services',
              details:
                'Flexible Part-Truck Load (PTL) and Full-Truck Load (FTL) options to optimize bulk shipping, reducing costs and improving efficiency.',
              img: '/images/services/whyChooseUs-2.webp',
            },
            {
              title: 'Powered By Technology',
              details:
                '10+ automated high-end sorters for faster & more accurate package handling. Real-Time Tracking and efficient order management.',
              img: '/images/services/whyChooseUs-3.webp',
            },
          ],
          heroImage: '/images/heroImage_1.png',
          isStyle: false,
        },
      },
      whyChooseData: [
        {
          image: '/images/Xpress-Solutions-for-Super-Fast-Deliveries.png',
          heading: t('app.WHY_CHOOSE_HEADING_1'),
          detail: t('app.WHY_CHOOSE_DETAIL_1'),
        },
        {
          image: '/images/Cost-Effective-Pricing.png',
          heading: t('app.WHY_CHOOSE_HEADING_2'),
          detail: t('app.WHY_CHOOSE_DETAIL_2'),
        },
        {
          image: '/images/Value-Added-Services.png',
          heading: t('app.WHY_CHOOSE_HEADING_3'),
          detail: t('app.WHY_CHOOSE_DETAIL_3'),
        },
        {
          image: '/images/Industry-Expertise.png',
          heading: t('app.WHY_CHOOSE_HEADING_4'),
          detail: t('app.WHY_CHOOSE_DETAIL_4'),
        },
      ],
      xbForWarehousing: {
        headerData: {
          header: 'Why choose XpressBees for ',
          subHeader: '3PL & Warehousing',
        },
        content: [
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
        ],
      },
      keyBenefitsDetails: {
        headerData: {
          header: 'Key Benefits of ',
          subHeader: 'XpressBees',
        },
        content: [
          {
            img: '/images/services/KeyBenefitsImg-1.webp',
            icon: '/images/services/KeyBenefitsIcon-1.webp',
            title: 'Delivery within 24 hours',
          },
          {
            img: '/images/services/KeyBenefitsImg-2.webp',
            icon: '/images/services/KeyBenefitsIcon-2.webp',
            title: '24X7 Customer Support',
          },
          {
            img: '/images/services/KeyBenefitsImg-3.webp',
            icon: '/images/services/KeyBenefitsIcon-3.webp',
            title: 'Multimodal International Shipping to 220+ Countries',
          },
          {
            img: '/images/services/KeyBenefitsImg-4.webp',
            icon: '/images/services/KeyBenefitsIcon-4.webp',
            title: 'Multi Package Shipment',
          },
          {
            img: '/images/services/KeyBenefitsImg-5.webp',
            icon: '/images/services/KeyBenefitsIcon-5.webp',
            title: 'Advanced Warehouse Management System',
          },
          {
            img: '/images/services/KeyBenefitsImg-6.webp',
            icon: '/images/services/KeyBenefitsIcon-6.webp',
            title: 'Efficient Operations',
          },
        ],
      },
      xpressBeesPlatformDetails: {
        technology: {
          info: 'Integration',
          title1: 'Seamless Integration',
          title2: 'with Leading Platforms',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: '',
              details:
                'XpressBees integrates effortlessly with major e-commerce platforms and marketplaces, making it easier for you to manage your logistics',
              img: '',
            },
            {
              title:
                'Woocommerce, Shopify, WareIQ, Shiprocket BigCommerce, Amazon, Flipkart, API Integrations',
              details: '',
              img: '',
            },
          ],
          heroImage: '/images/services/XpressBeesPlatformB2CImg.webp',
          isStyle: true,
        },
      },
      industriesData: {
        title: t('app.B2C_INDUSTRIES_TITLE'),
        industriesDetail: [
          {
            image: '/images/carousal/industries/b2c/Fashion-and-Apparel.jpg',
            heading: t('app.B2C_INDUSTRIES_1_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_1_DETAIL_1'),

              t('app.B2C_INDUSTRIES_1_DETAIL_2'),

              t('app.B2C_INDUSTRIES_1_DETAIL_3'),

              t('app.B2C_INDUSTRIES_1_DETAIL_4'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Banking-and-Finance.jpg',
            heading: t('app.B2C_INDUSTRIES_2_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_2_DETAIL_1'),

              t('app.B2C_INDUSTRIES_2_DETAIL_2'),

              t('app.B2C_INDUSTRIES_2_DETAIL_3'),
            ],
          },
          {
            image:
              '/images/carousal/industries/b2c/Consumer-Goods-and-FMCG.jpg',
            heading: t('app.B2C_INDUSTRIES_3_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_3_DETAIL_1'),
              t('app.B2C_INDUSTRIES_3_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Consumer-Electronics.jpg',
            heading: t('app.B2C_INDUSTRIES_4_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_4_DETAIL_1'),

              t('app.B2C_INDUSTRIES_4_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Ecommerce.jpg',
            heading: t('app.B2C_INDUSTRIES_5_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_5_DETAIL_1'),
              t('app.B2C_INDUSTRIES_5_DETAIL_2'),
              t('app.B2C_INDUSTRIES_5_DETAIL_3'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Pharmaceuticals.jpg',
            heading: t('app.B2C_INDUSTRIES_6_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_6_DETAIL_1'),

              t('app.B2C_INDUSTRIES_6_DETAIL_2'),
            ],
          },
        ],
      },
      faqData: [
        {
          question: t('app.B2C_FAQ_QUESTION_1'),
          answer: t('app.B2C_FAQ_ANSWER_1'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_4'),
          answer: t('app.B2C_FAQ_ANSWER_4'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_5'),
          answer: t('app.B2C_FAQ_ANSWER_5'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_6'),
          answer: t('app.B2C_FAQ_ANSWER_6'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_7'),
          answer: t('app.B2C_FAQ_ANSWER_7'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_8'),
          answer: t('app.B2C_FAQ_ANSWER_8'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_9'),
          answer: t('app.B2C_FAQ_ANSWER_9'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_10'),
          answer: t('app.B2C_FAQ_ANSWER_10'),
        },
      ],
      clientCarousel: [
        {
          img: '/images/carousal/client/adidas.jpg',
        },
        {
          img: '/images/carousal/client/nykaa.jpg',
        },
        {
          img: '/images/carousal/client/flipkart.jpg',
        },
        {
          img: '/images/carousal/client/trends.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/first-cry.jpg',
        },
        {
          img: '/images/carousal/client/bucket.jpg',
        },
        {
          img: '/images/carousal/client/lic.webp',
        },
        {
          img: '/images/carousal/client/meesho.jpg',
        },
        {
          img: '/images/carousal/client/m-caffeine.jpg',
        },
        {
          img: '/images/carousal/client/purple.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/wow.jpg',
        },
        {
          img: '/images/carousal/client/cliq.jpg',
        },
        {
          img: '/images/carousal/client/zara.jpg',
        },
        {
          img: '/images/carousal/client/rbl.jpg',
        },
        {
          img: '/images/carousal/client/Souled-Store.jpg',
        },
        {
          img: '/images/carousal/client/icici.jpg',
        },
        {
          img: '/images/carousal/client/ajio.jpg',
        },
        {
          img: '/images/carousal/client/au.webp',
        },
      ],
      howItWorksConfig: {
        headerData: {
          header: 'How It Works',
        },
        desktop: '/images/services/HowItsWorkB2CDesktopImg.webp',
        tablet: '/images/services/HowItsWorkB2CTabletImg.webp',
        mobile: '/images/services/HowItsWorkB2CMobileImg.webp',
      },
      xbFacilityDetails: {
        heading1: 'Xpress COD',
        heading2: ': Fast & Secure',
        headerStyle: {
          position: 'center',
          heading1Color: '#f58220',
          heading2Color: '#000000',
          isBackgroundColor: false,
        },
        cardData: [
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-1.svg',
            title: 'Cost-Effective Pricing',
            details: 'Shipping starts at ₹25*',
            color: '#FFFFFF',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: '#FFFFFF',
            icon: '/images/services/FacilitySectionImg-2.svg',
            title: 'Wide Network',
            details: 'Reach of 19,000+ Pincodes with PAN India Network',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: '#ffffff',
            icon: '/images/services/FacilitySectionImg-3.svg',
            title: 'WhatsApp / SMS',
            details: 'Seamless Updates to end customers.',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Dedicated Account Management',
            details:
              'Enjoy personalized service with a dedicated account manager',
            color: '#ffffff',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
        ],
        globalCardsStyle: {
          alignItems: 'flex-end',
        },
      },
    },
    2: {
      overview: {
        source: 'B2C Logistics',
        heroHeader: 'Revolutionize Your ',
        heroHeader2: 'E-commerce logistics with ',
        heroSubHeader: 'XpressBees',
        heroPara:
          'Effortlessly optimize your supply chain, expand your reach, and reduce costs while receiving personalized service from dedicated account managers.',
        image: '/images/services/OverviewImg.webp',
        title: t('app.OVERVIEW'),
        alt: 'B2C logistics services',
        paragraph: [t('app.OVERVIEW_PARAGRAPH_1')],
      },

      whyChooseUsDetails: {
        technology: {
          info: 'Technology',
          title1: 'Leading Platform with',
          title2: 'Most Advanced Solutions',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: 'Multimodal Shipping (Air/Surface Shipping)',
              details:
                'Choose the best mode of transportation-air or surface-to suit your business needs. Optimize cost and speed for every shipment.',
              img: '/images/services/whyChooseUs-1.webp',
            },
            {
              title: 'Customised Bulk Shipping  with PTL & FTL  Services',
              details:
                'Flexible Part-Truck Load (PTL) and Full-Truck Load (FTL) options to optimize bulk shipping, reducing costs and improving efficiency.',
              img: '/images/services/whyChooseUs-2.webp',
            },
            {
              title: 'Powered By Technology',
              details:
                '10+ automated high-end sorters for faster & more accurate package handling. Real-Time Tracking and efficient order management.',
              img: '/images/services/whyChooseUs-3.webp',
            },
          ],
          heroImage: '/images/heroImage_1.png',
          isStyle: false,
        },
      },
      whyChooseData: [
        {
          image: '/images/Xpress-Solutions-for-Super-Fast-Deliveries.png',
          heading: t('app.WHY_CHOOSE_HEADING_1'),
          detail: t('app.WHY_CHOOSE_DETAIL_1'),
        },
        {
          image: '/images/Cost-Effective-Pricing.png',
          heading: t('app.WHY_CHOOSE_HEADING_2'),
          detail: t('app.WHY_CHOOSE_DETAIL_2'),
        },
        {
          image: '/images/Value-Added-Services.png',
          heading: t('app.WHY_CHOOSE_HEADING_3'),
          detail: t('app.WHY_CHOOSE_DETAIL_3'),
        },
        {
          image: '/images/Industry-Expertise.png',
          heading: t('app.WHY_CHOOSE_HEADING_4'),
          detail: t('app.WHY_CHOOSE_DETAIL_4'),
        },
      ],
      xbForWarehousing: {
        headerData: {
          header: 'Why choose XpressBees for ',
          subHeader: '3PL & Warehousing',
        },
        content: [
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
        ],
      },
      keyBenefitsDetails: {
        headerData: {
          header: 'Key Benefits of ',
          subHeader: 'XpressBees',
        },
        content: [
          {
            img: '/images/services/KeyBenefitsImg-1.webp',
            icon: '/images/services/KeyBenefitsIcon-1.webp',
            title: 'Delivery within 24 hours',
          },
          {
            img: '/images/services/KeyBenefitsImg-2.webp',
            icon: '/images/services/KeyBenefitsIcon-2.webp',
            title: '24X7 Customer Support',
          },
          {
            img: '/images/services/KeyBenefitsImg-3.webp',
            icon: '/images/services/KeyBenefitsIcon-3.webp',
            title: 'Multimodal International Shipping to 220+ Countries',
          },
          {
            img: '/images/services/KeyBenefitsImg-4.webp',
            icon: '/images/services/KeyBenefitsIcon-4.webp',
            title: 'Multi Package Shipment',
          },
          {
            img: '/images/services/KeyBenefitsImg-5.webp',
            icon: '/images/services/KeyBenefitsIcon-5.webp',
            title: 'Advanced Warehouse Management System',
          },
          {
            img: '/images/services/KeyBenefitsImg-6.webp',
            icon: '/images/services/KeyBenefitsIcon-6.webp',
            title: 'Efficient Operations',
          },
        ],
      },
      xpressBeesPlatformDetails: {
        technology: {
          info: 'Integration',
          title1: 'Seamless Integration',
          title2: 'with Leading Platforms',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: '',
              details:
                'XpressBees integrates effortlessly with major e-commerce platforms and marketplaces, making it easier for you to manage your logistics',
              img: '',
            },
            {
              title:
                'Woocommerce, Shopify, WareIQ, Shiprocket BigCommerce, Amazon, Flipkart, API Integrations',
              details: '',
              img: '',
            },
          ],
          heroImage: '/images/services/XpressBeesPlatformB2CImg.webp',
          isStyle: true,
        },
      },
      industriesData: {
        title: t('app.B2C_INDUSTRIES_TITLE'),
        industriesDetail: [
          {
            image: '/images/carousal/industries/b2c/Fashion-and-Apparel.jpg',
            heading: t('app.B2C_INDUSTRIES_1_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_1_DETAIL_1'),

              t('app.B2C_INDUSTRIES_1_DETAIL_2'),

              t('app.B2C_INDUSTRIES_1_DETAIL_3'),

              t('app.B2C_INDUSTRIES_1_DETAIL_4'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Banking-and-Finance.jpg',
            heading: t('app.B2C_INDUSTRIES_2_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_2_DETAIL_1'),

              t('app.B2C_INDUSTRIES_2_DETAIL_2'),

              t('app.B2C_INDUSTRIES_2_DETAIL_3'),
            ],
          },
          {
            image:
              '/images/carousal/industries/b2c/Consumer-Goods-and-FMCG.jpg',
            heading: t('app.B2C_INDUSTRIES_3_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_3_DETAIL_1'),
              t('app.B2C_INDUSTRIES_3_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Consumer-Electronics.jpg',
            heading: t('app.B2C_INDUSTRIES_4_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_4_DETAIL_1'),

              t('app.B2C_INDUSTRIES_4_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Ecommerce.jpg',
            heading: t('app.B2C_INDUSTRIES_5_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_5_DETAIL_1'),
              t('app.B2C_INDUSTRIES_5_DETAIL_2'),
              t('app.B2C_INDUSTRIES_5_DETAIL_3'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Pharmaceuticals.jpg',
            heading: t('app.B2C_INDUSTRIES_6_HEADING'),
            detail: [
              t('app.B2C_INDUSTRIES_6_DETAIL_1'),

              t('app.B2C_INDUSTRIES_6_DETAIL_2'),
            ],
          },
        ],
      },
      faqData: [
        {
          question: t('app.B2C_FAQ_QUESTION_1'),
          answer: t('app.B2C_FAQ_ANSWER_1'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_4'),
          answer: t('app.B2C_FAQ_ANSWER_4'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_5'),
          answer: t('app.B2C_FAQ_ANSWER_5'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_6'),
          answer: t('app.B2C_FAQ_ANSWER_6'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_7'),
          answer: t('app.B2C_FAQ_ANSWER_7'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_8'),
          answer: t('app.B2C_FAQ_ANSWER_8'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_9'),
          answer: t('app.B2C_FAQ_ANSWER_9'),
        },
        {
          question: t('app.B2C_FAQ_QUESTION_10'),
          answer: t('app.B2C_FAQ_ANSWER_10'),
        },
      ],
      clientCarousel: [
        {
          img: '/images/carousal/client/adidas.jpg',
        },
        {
          img: '/images/carousal/client/nykaa.jpg',
        },
        {
          img: '/images/carousal/client/flipkart.jpg',
        },
        {
          img: '/images/carousal/client/trends.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/first-cry.jpg',
        },
        {
          img: '/images/carousal/client/bucket.jpg',
        },
        {
          img: '/images/carousal/client/lic.webp',
        },
        {
          img: '/images/carousal/client/meesho.jpg',
        },
        {
          img: '/images/carousal/client/m-caffeine.jpg',
        },
        {
          img: '/images/carousal/client/purple.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/wow.jpg',
        },
        {
          img: '/images/carousal/client/cliq.jpg',
        },
        {
          img: '/images/carousal/client/zara.jpg',
        },
        {
          img: '/images/carousal/client/rbl.jpg',
        },
        {
          img: '/images/carousal/client/Souled-Store.jpg',
        },
        {
          img: '/images/carousal/client/icici.jpg',
        },
        {
          img: '/images/carousal/client/ajio.jpg',
        },
        {
          img: '/images/carousal/client/au.webp',
        },
      ],
      howItWorksConfig: {
        headerData: {
          header: 'How It Works',
        },
        desktop: '/images/services/HowItsWorkB2CDesktopImg.webp',
        tablet: '/images/services/HowItsWorkB2CTabletImg.webp',
        mobile: '/images/services/HowItsWorkB2CMobileImg.webp',
      },
      xbFacilityDetails: {
        heading1: 'Xpress COD',
        heading2: ': Fast & Secure',
        headerStyle: {
          position: 'center',
          heading1Color: '#f58220',
          heading2Color: '#000000',
          isBackgroundColor: false,
        },
        cardData: [
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-1.svg',
            title: 'Cost-Effective Pricing',
            details: 'Shipping starts at ₹25*',
            color: '#FFFFFF',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: '#FFFFFF',
            icon: '/images/services/FacilitySectionImg-2.svg',
            title: 'Wide Network',
            details: 'Reach of 19,000+ Pincodes with PAN India Network',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: '#ffffff',
            icon: '/images/services/FacilitySectionImg-3.svg',
            title: 'WhatsApp / SMS',
            details: 'Seamless Updates to end customers.',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Dedicated Account Management',
            details:
              'Enjoy personalized service with a dedicated account manager',
            color: '#ffffff',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
        ],
        globalCardsStyle: {
          alignItems: 'flex-end',
        },
      },
    },
  };
};
